import type { LoginTrackBids } from '../types';

import { getH5CashLoanUrl } from '@/apps/MXCashLoanBALL/utils/jumpTo';
import { getH5CreditCardUrl } from '@/apps/MXCreditCardBALL/utils/jumpTo';
import { initializePreloadIframe, loginSuccessIframe } from '@/utils/preload';

const PRELOAD_URL_BY_PASSPORT_VERIFY_BID: Record<string, () => string> = {
    fin_loan_abroad_sign_phone_passport_verif_bt: getH5CashLoanUrl,
    fin_credit_abroad_sign_phone_passport_verif_bt: getH5CreditCardUrl
};

export const resolvePreloadUrlByBids = (bids: LoginTrackBids): string | null => {
    const getUrl = PRELOAD_URL_BY_PASSPORT_VERIFY_BID[bids.passportVerify];

    return getUrl ? getUrl() : null;
};

export const initFifaPreloadIframe = (bids: LoginTrackBids) => {
    if (window.preloader) {
        return;
    }

    const url = resolvePreloadUrlByBids(bids);

    if (!url) {
        console.error(
            '[fifaLogin] preload url not found for passportVerify bid:',
            bids.passportVerify
        );

        return;
    }

    initializePreloadIframe(url, false);
};

export const fifaLoginSuccessIframe = (raw: unknown) => {
    loginSuccessIframe(raw);
};
